import Crud from '../components/ProcessName/Crud'
import Add from '../components/ProcessName/Add'
import Edit from '../components/ProcessName/Edit'

let routes = {
    path: '/process_names',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/process_names/add',
            name: 'Novo Registro',
            component: Add
        },
        {
            path: '/process_names/edit/:id?',
            name: 'Editar Registro',
            component: Edit
        },
        {
            path: '/process_names',
            name: 'Registros',
            component: Crud
        },
    ]
};


export default routes
